// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".highlighted[data-v-f2c1c23e] {\n  border: 3px solid #abc74a;\n}\n.release-title[data-v-f2c1c23e] {\n  color: #0e6488;\n  font-size: 35px;\n}\n.release-wrapper[data-v-f2c1c23e] {\n  max-width: 470px;\n}\n.release-wrapper .release-card[data-v-f2c1c23e] {\n  min-height: 400px;\n}", ""]);
// Exports
module.exports = exports;
